module.exports = __webpack_public_path__ + "img/pelican.3d30426.png";